import React from 'react';
import EnableContainer from './EnabledContainer';
import { IMultiSelProps, StatusTypes } from './types';
import DoneIcon from '@mui/icons-material/Done';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import ArticleIcon from '@mui/icons-material/Article';

const MultiStatusSelector = (props: IMultiSelProps) => {
  const { status, labelStatus } = props;
  let Status = <></>;

  switch (status) {
  case StatusTypes.successful:
    Status = (<EnableContainer label={labelStatus} color={'#0ACC30'}
      icon={<DoneIcon />}/>);
    break;
  case StatusTypes.completed:
    Status = (<EnableContainer label={labelStatus} color={'#0ACC30'}
      icon={<DoneIcon />}/>);
    break;
  case StatusTypes.under_update:
    Status = (<EnableContainer label={labelStatus} color={'#01579B'}
      icon={<InfoIcon />}/>);
    break;
  case StatusTypes.in_progress:
    Status = (<EnableContainer label={labelStatus} color={'#E65100'}
      icon={<AutorenewIcon />}/>);
    break;
  case StatusTypes.rejected:
    Status = (<EnableContainer label={labelStatus} color={'#c62828'}
      icon={<WarningIcon />}/>);
    break;
  case StatusTypes.draft: 
    Status = (<EnableContainer label={labelStatus} color={'#grey'}
      icon={<ArticleIcon />}/>);
    break;
  default: {
    Status = (<></>);
  }
  } 
  return Status;
};


export default MultiStatusSelector;